import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import WelcomeIntro from './index';

const WelcomeIntroWithSlug = () => {
  const { welcomeSlug } = useLocalSearchParams();

  return <WelcomeIntro welcomeSlug={welcomeSlug as string} />;
};

export default WelcomeIntroWithSlug;
